module.exports = __webpack_public_path__ + "static/media/CAKE.0451a282.svg";